import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "2rem",
  height: "calc(100vh - 20rem)",
}));

const Title = styled.div(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: "500",
  color: theme.color.gray,
}));

const NoSearch = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Container>
      <Image
        src={theme.image.warning_circle_thin.default}
        width="4.8rem"
        height="4.8rem"
      />
      <Title>{t("검색 내역이 없습니다.")}</Title>
    </Container>
  );
};

export default NoSearch;
